export var QualityDataScore;
(function (QualityDataScore) {
    QualityDataScore["DESC"] = "desc";
})(QualityDataScore || (QualityDataScore = {}));
